import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { container } from '@Container';
import { TYPES } from '@Types';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import BookActionComponent from '@Components/publication/book-action/book-action.component';
import { ArmyBookAction } from '@Redux/actions';
import Loader from '@Components/utils/loader/loader.component';
import ArmyBookMakeForm from '@Components/publication/army/make/army-book-make.form.component';
import { ArmyBookActionState } from '@Stores/publication/army-book.state';
import ArmyBookPrintComponent from '@Components/publication/army/print/army-book-print.component';

const PublicationArmyBookPageMake: React.FC<Props> = ({
  book,
  isLoading,
  load,
  actions,
}) => {
  const params = useParams();

  React.useEffect(() => {
    load(params.army_id!);
  }, []);

  if (isLoading || !book) {
    return <Loader />;
  }

  const currentLocale = document.documentElement.lang;

  const onSubmit = (values: any) => {};

  return (
    <>
      <BookActionComponent />

      <Breadcrumb tag="nav">
        <BreadcrumbItem tag="a" href={`/${currentLocale}/builder/army_lists`}>
          <i className="fa-solid fa-house"></i>
        </BreadcrumbItem>
        <BreadcrumbItem tag="a" href={`/${currentLocale}/publication/books`}>
          Publications Armies
        </BreadcrumbItem>
        <BreadcrumbItem tag="span" active>
          {book.name}
        </BreadcrumbItem>
      </Breadcrumb>

      {actions.make && (
        <ArmyBookMakeForm army={book} disabled={false} onSubmit={onSubmit} />
      )}
      {actions.print && (
        <ArmyBookPrintComponent />
      )}
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  book: state.armyBook.entity,
  isLoading: state.armyBook.isLoading,
  actions: {
    make: !state.armyBook.action,
    print: state.armyBook.action === ArmyBookActionState.Print,
  },
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<ArmyBookAction>(
    TYPES.Actions.Publication.ArmyBookAction,
  );
  return {
    load: (id: string) => dispatch(action.fetchData({ entityId: id })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublicationArmyBookPageMake);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
